import Vue from "vue";

const getDefaultState = () => {
	return {
		notifications: [],
		active: {
			data: {}
		}
	};
};

const Notifications = {
	namespaced: true,
	state: getDefaultState(),
	mutations: {
		RESET_STATE: state => {
			Object.assign(state, getDefaultState());
		},

		SET_NOTIFICATIONS: (state, payload) => {
			state.notifications = payload;
		},

		SET_ACTIVE: (state, payload) => {
			state.active = payload;
		},
	},

	actions: {
		resetState: ({ commit }) => {
			commit("RESET_STATE");
		},

		fetch: ({ commit, rootState }) => {
			return Vue.prototype.$apiService
				.get(`accounts/${rootState.User.account.id}/notifications`, {
					params: {
						read: 0
					}
				})
				.then(response => {
					commit("SET_NOTIFICATIONS", response.data);

					if (rootState.Projects.image && lutify.activePreviewsSidebarContainer == 'comments') {
						lutify.markNewCommentNotificationsAsRead();
					}

					return response.data;
				})
				.catch(err => console.log(err.response));
		},

		markAsRead: ({ rootState, dispatch }, payload) => {
			let formData = new FormData();
			payload.forEach((notification, key) => {
				formData.append(`notification_ids[${key}]`, notification.id);
			})

			return Vue.prototype.$apiService
				.post(`accounts/${rootState.User.account.id}/notifications/markAsRead`, formData)
				.then(response => {
					dispatch('fetch');
					return response.data;
				})
				.catch(err => console.log(err.response));
		},

		markAllAsRead: ({ rootState, dispatch }) => {
			return Vue.prototype.$apiService
				.post(`accounts/${rootState.User.account.id}/notifications/markAsRead`)
				.then(response => {
					dispatch('fetch');
					return response.data;
				})
				.catch(err => console.log(err.response));
		},

		setActive: ({ commit }, payload) => {
			commit('SET_ACTIVE', payload);
		},

		followNotification: ({ dispatch, state, rootGetters }) => {
			let payload = [];

			if (state.active.type == "App\\Notifications\\NewFileCreated") {
				payload = [
					rootGetters["Projects/binById"](state.active.data.bin_id),
					rootGetters["Projects/folderBySlug"]('media', state.active.data.bin_id),
				];
			} else {
				payload = [
					rootGetters["Projects/binById"](state.active.data.bin_id),
					rootGetters["Projects/folderBySlug"](state.active.data.channel, state.active.data.bin_id),
				];
			}

			dispatch('Projects/openProjectTree', payload, { root: true });

			if (state.active.type !== "App\\Notifications\\NewFileCreated") {
				Vue.nextTick(() => {
					setTimeout(() => {
						if (state.active.data.channel == 'shared') {
							if (rootGetters["User/isGuest"]) $('#project-tree').find(`[file][parent-file-id="${state.active.data.file_id}"] .file-name`).first().trigger('click');
							else $('#project-tree').find(`[file][folder-id="${payload[1].id}"][parent-file-id="${state.active.data.file_id}"] .file-name`).first().trigger('click');
						} else {
							$('#project-tree').find(`[file][folder-id="${payload[1].id}"][file_id="${state.active.data.file_id}"] .file-name`).first().trigger('click');
						}

						dispatch('UI/setRightColumn', 'comments', { root: true });
					}, 100)
				})
			}

			dispatch("Loader/showProgressBar", false, { root: true });
		}
	},

	getters: {
		unreadNotificationsCount: state => {
			return state.notifications.filter(notification => !notification.read_at).length;
		},

		notificationsOfActiveOrganization: (state, getters, rootState) => {
			return state.notifications.filter(notification => notification.data.organization_id == rootState.Organizations.organization.id);
		},

		notificationsOfNonActiveOrganization: (state, getters, rootState) => {
			return state.notifications.filter(notification => notification.data.organization_id !== rootState.Organizations.organization.id);
		},

		notificationsOfOrganization: (state, getters, rootState) => organization_id => {
			return state.notifications.filter(notification => notification.data.organization_id == organization_id);
		},

		notificationsOfFile: state => file_id => {
			return state.notifications.filter(notification => notification.data.file_id == file_id);
		},

		newCommentNotificationsOfFile: state => (file_id, channel = 'media') => {
			return state.notifications.filter(notification =>
				notification.type == "App\\Notifications\\NewMessageCreated" &&
				notification.data.file_id == file_id &&
				!notification.data.is_mention &&
				notification.data.channel == channel
			);
		},

		newCommentNotificationsOfFolder: (state, getters) => (bin_id, channel) => {
			return state.notifications.filter(notification =>
				notification.type == "App\\Notifications\\NewMessageCreated" &&
				notification.data.bin_id == bin_id &&
				!notification.data.is_mention &&
				notification.data.channel == channel
			);
		},

		newCommentNotificationsOfBin: state => bin_id => {
			return state.notifications.filter(notification =>
				notification.type == "App\\Notifications\\NewMessageCreated" &&
				notification.data.bin_id == bin_id &&
				!notification.data.is_mention
			);
		},

		newCommentNotificationsOfProject: (state, getters, rootState) => {
			return state.notifications.filter(notification =>
				notification.type == "App\\Notifications\\NewMessageCreated" &&
				notification.data.project_id == rootState.Projects.project.id &&
				!notification.data.is_mention
			);
		}
	},
};

export default Notifications;
